(function () {
  function settingsValue(maybeFnOrObj) {
    return typeof maybeFnOrObj === 'function' ? maybeFnOrObj() : (maybeFnOrObj || {});
  }

  function initProductMediaSliders(sectionRoot) {
    const scope = sectionRoot && sectionRoot.querySelector ? sectionRoot : document;

    const mainEl = scope.querySelector('.js-media-list');
    const thumbsEl = scope.querySelector('.js-media-sublist');

    if (!mainEl || !thumbsEl) return;

    // Prevent double init
    if (mainEl.swiper) mainEl.swiper.destroy(true, true);
    if (thumbsEl.swiper) thumbsEl.swiper.destroy(true, true);

    // Support both patterns: settings as function OR object
    const mainSettings = settingsValue(window.getSliderSettings);
    const thumbsSettings = settingsValue(window.getSubSliderProductSettings);

    // Thumbnails slider (vertical on desktop, horizontal on mobile)
    const thumbsSwiper = new Swiper(
      thumbsEl,
      Object.assign(
        {
          watchSlidesProgress: true,
          freeMode: true,
          slideToClickedSlide: true,
          spaceBetween: 10,

          // Desktop: allow scrolling thumbnails with mouse wheel + show grab cursor
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 0.8,
          },
          grabCursor: true,

          breakpoints: {
            0: {
              direction: 'horizontal',
              slidesPerView: 4,
            },
            990: {
              direction: 'vertical',
              slidesPerView: 5,
            },
          },
        },
        thumbsSettings
      )
    );

    // Main slider
    const mainSwiper = new Swiper(
      mainEl,
      Object.assign(
        {
          slidesPerView: 1,
          spaceBetween: 0,

          // Connect thumbs -> main
          thumbs: { swiper: thumbsSwiper },
        },
        mainSettings
      )
    );

    // Force buttons to work (no Navigation module needed)
    const nextBtn = scope.querySelector('.swiper-btn--next');
    const prevBtn = scope.querySelector('.swiper-btn--prev');

    if (nextBtn) {
      nextBtn.onclick = (e) => {
        e.preventDefault();
        if (!mainSwiper.destroyed) mainSwiper.slideNext();
      };
    }

    if (prevBtn) {
      prevBtn.onclick = (e) => {
        e.preventDefault();
        if (!mainSwiper.destroyed) mainSwiper.slidePrev();
      };
    }

    // Fallback: click thumbs -> main (even if Thumbs module is missing)
    thumbsEl.querySelectorAll('.swiper-slide').forEach((slide, index) => {
      slide.addEventListener('click', () => {
        if (!mainSwiper.destroyed) mainSwiper.slideTo(index);
      });
    });

    setTimeout(() => {
      if (!mainSwiper.destroyed) mainSwiper.update();
      if (!thumbsSwiper.destroyed) thumbsSwiper.update();
    }, 100);
  }

  const initProductAccordion = () => {
    $('.about__accordion-button')
      .off('click')
      .on('click', function () {
        if (!$(this).hasClass('active')) {
          $('.about__accordion-button.active').removeClass('active');
          $(this).addClass('active');
          $('.about__accordion-text').stop().slideUp(300);
          $(this).siblings('.about__accordion-text').eq($(this).index()).stop().slideDown(300);
        } else {
          $(this).removeClass('active');
          $(this).siblings('.about__accordion-text').stop().slideUp(300);
        }
      });
  };

  // Live page: init each product section on the page
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="MainProduct-"]').forEach((sectionEl) => {
      initProductMediaSliders(sectionEl);
    });
    initProductAccordion();
  });

  // Theme editor reload: init only the reloaded section
  document.addEventListener('shopify:section:load', function (e) {
    initProductMediaSliders(e.target);
    initProductAccordion();
  });
})();